import { Stack } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Bar, BarChart, CartesianGrid, Cell, LabelList, Legend, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { OverallDataContext } from '../../pages/CalculatorPage';

const COLORS = {
    // ids assigned in backend
    'transport': '#203864',
    'hotel': '#800000',
    'onsite': '#7F6000',
    'total': '#7C9AD2',
};

function CustomTick({ x, y, payload }) {
	return (
		<g transform={`translate(${x},${y})`}>
			<text x={0} y={0} dy={4} fontSize={"0.8em"} textAnchor='end' >{payload.value}</text>
		</g>
	)
}

const CustomLabel = (props) => {
	const { x, y, width, height, value } = props;
	return (
		<>
		{ parseFloat(value) > 0 &&
		<g>
		<text x={x + width / 2} y={y + height / 2} fontSize={"0.8em"} fill="#fff" textAnchor="middle" dominantBaseline="middle">
			{value}
		</text>
		</g>
		}
		</>
	);
};

export default function ResultBarChart({ barDataObj }) {
	const selectedFootprintCategories = useContext(OverallDataContext).selectedFootprintCategories[0];
	
	const [barData, setBarData] = useState([]);

    const setUpDataArray = (dataObj) => {
        let dataArray = [];
        Object.entries(dataObj).forEach( ([key, obj]) => {
            dataArray.push(
                {
                    label: obj.label,
					Total: obj?.value?.total?.toFixed(0) || null,
					Transport: obj?.value?.transport?.toFixed(0) || null,
					Accommodations: obj?.value?.hotel?.toFixed(0) || null,
					Onsite: obj?.value?.onsite?.toFixed(0) || null,
                }
            )
        });
        return dataArray;
    }

	useEffect(() => {
        setBarData(setUpDataArray(barDataObj));
    },[barDataObj]);

	return (
	<ResponsiveContainer minWidth={400} width="100%" height={280}>
		<BarChart
		layout='vertical'
		width="100%"
		data={barData}
		barCategoryGap={2}
		margin={{
			top: 5,
			right: 30,
			left: 60,
			bottom: 5,
		}}
		>
		<CartesianGrid strokeDasharray="3 3" />
		<XAxis type="number" />
		<YAxis type="category" dataKey="label" tick={<CustomTick />} />

		<Legend
			content={({ payload }) => {
				const filtered = payload.filter(entry => selectedFootprintCategories[entry.dataKey.toLowerCase()] || entry.dataKey === 'Total' );

				return (
					<Stack spacing={4} direction={'row'} sx={{ justifyContent: 'center' }}>
					{filtered.map((entry, index) => (
						<span key={`item-${index}`} style={{ color: entry.color, fontSize: '0.8em' }}>
						&#x25A0; {entry.value.charAt(0).toUpperCase() + entry.value.slice(1).toLowerCase()}
						</span>
					))}
					</Stack>
				);
			}}
		/>

		<Bar dataKey="Transport" stackId="a" fill={COLORS['transport']} >
			{barData.map((entry, index) => (
				<Cell key={`cell-${index}`} fill={COLORS['transport']} />
			))}
			<LabelList dataKey="Transport" content={CustomLabel}/>
		</Bar>
		<Bar dataKey="Accommodations" stackId="a" fill={COLORS['hotel']} >
			{barData.map((entry, index) => (
				<Cell key={`cell-${index}`} fill={COLORS['hotel']} />
			))}
			<LabelList dataKey="Accommodations" content={CustomLabel}/>
		</Bar>
		<Bar dataKey="Onsite" stackId="a" fill={COLORS['onsite']} >
			{barData.map((entry, index) => (
				<Cell key={`cell-${index}`} fill={COLORS['onsite']} />
			))}
			<LabelList dataKey="Onsite" content={CustomLabel}/>
		</Bar>
		<Bar dataKey="Total" stackId="a" fill={COLORS['total']} >
			{barData.map((entry, index) => (
				<Cell key={`cell-${index}`} fill={COLORS['total']} />
			))}
			<LabelList dataKey="Total" content={CustomLabel}/>
		</Bar>
		</BarChart>
	</ResponsiveContainer>
	);
}
